import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { NavigationMenuEntry } from '@app/shared/core/models/navigation-menu-entry.interface';
import { basicLayoutActions } from '../../state/actions';
import { XROSSOVER_APP_LOGIN } from '@app/shared/constants/xross-over-external-urls.constant';

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NavBarComponent {
  @Input() menuItems: NavigationMenuEntry[] = [];
  @Input() currentRoute!: string;

  constructor(private store: Store) {}

  openSidebar() {
    this.store.dispatch(basicLayoutActions.setSidebarVisibility({ opened: true }));
  }

  goToStore() {
    window.open(XROSSOVER_APP_LOGIN);
  }
}
